'use es6';

import { createSelector } from 'reselect';
import { PICKER_CHANGE_VISIBILITY_SOURCE } from 'FileManagerCore/Constants';
import getQueryFromLocation from '../utils/getQueryFromLocation';
import { SEARCH_QUERY_PARAM_NAME } from '../utils/urls';
import { parseQueryObject } from '../utils/location';
const getLocation = (state, props) => props && props.location;
export const getQueryParams = createSelector([getLocation], parseQueryObject);
export const getQueryWithDefaults = createSelector([getLocation], getQueryFromLocation);
export const getSearchQueryFromUrl = createSelector([getQueryParams], queryObj => queryObj[SEARCH_QUERY_PARAM_NAME]);
export const getSourceParam = createSelector([getQueryParams], query => query.source);
export const getIsFromPickerChangeVisibility = createSelector([getSourceParam], source => source === PICKER_CHANGE_VISIBILITY_SOURCE);